import React, { useState } from 'react';
import ViewPanel from '../panels/ViewPanel';

const NAV_ITEMS = [
  { label: 'Discount Codes', caption: 'Coupons' },
  { label: 'Default Sessions', caption: 'Templates' },
  { label: 'Users', caption: 'Accounts' },
  { label: 'Email', caption: 'Campaigns' },
  { label: 'Utils', caption: 'Operations' },
];

function TopNav({ user, onLogout }) {
  return (
    <header className="h-16 border-b border-gray-800 bg-[#080c16] text-white">
      <div className="flex h-full items-center justify-between px-5 sm:px-7">
        <div className="flex items-center gap-3">
          <div className="rounded-md border border-cyan-300/20 bg-cyan-300/10 px-3 py-2 text-xs font-black uppercase tracking-[0.18em] text-cyan-100">
            samsar
          </div>
          <div className="text-left">
            <h1 className="text-base font-semibold text-gray-100">Admin</h1>
            <p className="text-xs text-gray-500">Control center</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="hidden text-right sm:block">
            <p className="max-w-56 truncate text-xs font-medium text-gray-300">{user?.email}</p>
            <p className="text-[11px] text-gray-500">Administrator</p>
          </div>
          <button
            type="button"
            onClick={onLogout}
            className="rounded-md border border-gray-700 bg-gray-900 px-3 py-2 text-xs font-medium text-gray-300 hover:border-gray-600 hover:text-white"
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}

function LeftNav({ selectedTab, onSelectTab }) {
  return (
    <aside className="h-full border-r border-gray-800 bg-[#0a0f1d] px-3 py-5 text-white">
      <div className="mb-4 px-3 text-left text-[11px] font-semibold uppercase tracking-[0.22em] text-gray-500">
        Workspace
      </div>
      <nav className="space-y-1.5">
        {NAV_ITEMS.map((item) => {
          const isActive = selectedTab === item.label;
          return (
            <button
              key={item.label}
              type="button"
              onClick={() => onSelectTab(item.label)}
              className={`group flex w-full items-center justify-between rounded-lg border px-3 py-3 text-left transition-colors ${
                isActive
                  ? 'border-cyan-300/20 bg-cyan-300/10 text-cyan-50 shadow-[inset_3px_0_0_rgba(103,232,249,0.75)]'
                  : 'border-transparent text-gray-400 hover:border-gray-800 hover:bg-gray-900/80 hover:text-gray-100'
              }`}
            >
              <span>
                <span className="block text-sm font-semibold">{item.label}</span>
                <span className="mt-0.5 block text-xs text-gray-500 group-hover:text-gray-400">
                  {item.caption}
                </span>
              </span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
}

export default function Landing({ user, onLogout }) {
  const [selectedTab, setSelectedTab] = useState('Discount Codes');

  return (
    <div className="min-h-screen bg-[#070b14] text-gray-100">
      <TopNav user={user} onLogout={onLogout} />
      <div className="flex min-h-[calc(100vh-64px)]">
        <div className="hidden w-[260px] shrink-0 md:block">
          <LeftNav selectedTab={selectedTab} onSelectTab={setSelectedTab} />
        </div>
        <div className="min-w-0 flex-1 overflow-y-auto">
          <div className="border-b border-gray-800 bg-[#0a0f1d] px-4 py-3 md:hidden">
            <div className="flex gap-2 overflow-x-auto">
              {NAV_ITEMS.map((item) => (
                <button
                  key={item.label}
                  type="button"
                  onClick={() => setSelectedTab(item.label)}
                  className={`whitespace-nowrap rounded-full border px-3 py-2 text-sm font-medium ${
                    selectedTab === item.label
                      ? 'border-cyan-300/30 bg-cyan-300/10 text-cyan-50'
                      : 'border-gray-800 text-gray-400'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
          <main className="mx-auto w-full max-w-[1500px] px-5 py-6 sm:px-8 lg:px-10 lg:py-8">
            <ViewPanel selectedTab={selectedTab} />
          </main>
        </div>
      </div>
    </div>
  );
}
